import ImportListImage from "assets/import_list.svg";
import React, {useCallback, useEffect} from "react";
import {Button, DownloadIcon, ExcelColorIcon, Flex, Image, Text} from "@fluentui/react-northstar";
import languageObject from "../../../../translations";
import {useFilePicker} from "use-file-picker";

type Props = {
    onFileSelected: (fileContent: ArrayBuffer) => void,
}

export const SelectFile = (props: Props) => {

    const {openFilePicker, filesContent, errors, loading, clear} = useFilePicker({
        multiple: false,
        readAs: 'ArrayBuffer',
        accept: [
            "application/vnd.ms-excel",
            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            "application/vnd.oasis.opendocument.spreadsheet"
        ],
    });

    const handleDownloadTemplate = useCallback(() => {
        const link = document.createElement("a");
        link.href = "/assets/files/template.xlsx";
        link.download = "template.xlsx";
        link.click();
        link.remove();
    }, []);

    useEffect(() => {
        if (loading) return;
        if (filesContent.length !== 1) return;
        const fileContent = filesContent[0].content;
        if (!fileContent) return;
        props.onFileSelected(fileContent);
        clear();
    }, [filesContent, loading]);

    return (
        <Flex fill column hAlign={"center"} vAlign={"center"} gap={"gap.small"}>
            <Image fluid src={ImportListImage} styles={{height: "250px", minHeight: "250px", objectFit: "contain"}}/>
            <Flex column hAlign={"center"} gap={"gap.medium"}>
                <Flex column hAlign={"center"} styles={{gap: "5px"}}>
                    <Text size={"large"} weight={"bold"} content={languageObject.translate("ImportYourMailingList")}/>
                    <Text content={languageObject.translate("PleaseSelectAnExcelFile")}/>
                </Flex>
                <Flex column hAlign={"center"} gap={"gap.small"}>
                    <Button
                        icon={<DownloadIcon outline/>}
                        content={languageObject.translate("DownloadTemplate")}
                        onClick={handleDownloadTemplate}
                    />
                    <Button
                        icon={<ExcelColorIcon/>} primary
                        content={languageObject.translate("SelectAFile")}
                        onClick={openFilePicker}
                    />
                </Flex>
            </Flex>
        </Flex>
    )
}